import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { computed, ref } from "vue";
import { ActionInternal } from "@/keyboard";
import { useKeyboardStore, useHelpStore, useHighlightStore } from "@/stores";
import { useOnClickOutside } from "@/composables";
import PopUp from "@/components/utils/PopUp.vue";
import ActionMenu from "@/components/actions/ActionMenu.vue";
import KeyCap from "@/components/keys/KeyCap.vue";

type KeyCapT = InstanceType<typeof KeyCap>;
type DragEventName =
  | "dragstart"
  | "dragenter"
  | "dragleave"
  | "dragover"
  | "dragend"
  | "drop";

export default /*@__PURE__*/_defineComponent({
  __name: 'KeyboardButton',
  props: {
    x: {},
    y: {},
    rot: {},
    height: {},
    width: {},
    row: {},
    col: {}
  },
  emits: ["opened", "closed", "dragstart", "dragenter", "dragleave", "dragover", "dragend", "drop"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const kb = useKeyboardStore();
const help = useHelpStore();
const hl = useHighlightStore();

const keycap = ref<InstanceType<typeof KeyCap> | null>(null);
const popup = ref<InstanceType<typeof PopUp> | null>(null);
const root = ref<HTMLElement | null>(null);

const hidden = ref(true);
const helpIsSelected = () => help.isKeySelected(props.row, props.col);
const action = computed(
  (): ActionInternal =>
    helpIsSelected() && help.overrideKeyAction != null
      ? help.overrideKeyAction
      : kb.getAction(props.row, props.col)
);

const emitDrag = (name: DragEventName, e: DragEvent) => {
  if (keycap.value != null) {
    emit(name, e, keycap.value);
  }
};

// Open/close logic
const isOpen = computed(() => !hidden.value);
const close = () => {
  hidden.value = true;
  emit("closed");
};
const open = () => {
  hidden.value = false;
  // popper.update();
  emit("opened");
};
const toggle = () => (isOpen.value ? close() : open());

__expose({ isOpen, close, open, toggle, keycap });

// Close popup on "click outside"
useOnClickOutside(root, close);

// Adjust popper when action (and so content) changes
const onNewAction = (act: ActionInternal) => {
  kb.setAction(props.row, props.col, act);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root
  }, [
    _createVNode(KeyCap, {
      ref_key: "keycap",
      ref: keycap,
      row: _ctx.row,
      col: _ctx.col,
      x: _ctx.x,
      y: _ctx.y,
      rot: _ctx.rot,
      height: _ctx.height,
      width: _ctx.width,
      selected: isOpen.value,
      highlighted: _unref(hl).isHighlightedKey(_ctx.row, _ctx.col),
      onClick: toggle,
      draggable: "true",
      onDragstart: _cache[0] || (_cache[0] = (e) => emitDrag('dragstart', e)),
      onDragenter: _cache[1] || (_cache[1] = (e) => emitDrag('dragenter', e)),
      onDragleave: _cache[2] || (_cache[2] = (e) => emitDrag('dragleave', e)),
      onDragover: _cache[3] || (_cache[3] = _withModifiers((e) => emitDrag('dragover', e), ["prevent"])),
      onDragend: _cache[4] || (_cache[4] = (e) => emitDrag('dragend', e)),
      onDrop: _cache[5] || (_cache[5] = _withModifiers((e) => emitDrag('drop', e), ["prevent"])),
      class: _normalizeClass(["dragover:saturate-[.3]", helpIsSelected() ? 'tour-key-cap' : ''])
    }, null, 8, ["row", "col", "x", "y", "rot", "height", "width", "selected", "highlighted", "class"]),
    (!hidden.value || (helpIsSelected() && _unref(help).keyMenuExpand))
      ? (_openBlock(), _createBlock(PopUp, {
          key: 0,
          ref_key: "popup",
          ref: popup,
          show: true,
          reference: keycap.value?.$el,
          placement: _ctx.col < _unref(kb).columns / 2 ? 'right' : 'left',
          offset: -7
        }, {
          default: _withCtx(() => [
            _createVNode(ActionMenu, {
              class: _normalizeClass(helpIsSelected() ? 'tour-key-menu' : ''),
              action: action.value,
              onNewAction: onNewAction,
              cacheKey: `${_ctx.row}-${_ctx.col}`
            }, null, 8, ["class", "action", "cacheKey"])
          ]),
          _: 1
        }, 8, ["reference", "placement"]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})